import { render, staticRenderFns } from "./bindDialog.vue?vue&type=template&id=4820d830&scoped=true&"
import script from "./bindDialog.vue?vue&type=script&lang=js&"
export * from "./bindDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820d830",
  null
  
)

export default component.exports